export type LabMaterial = {
    _id?: string;
    materialCode: string;
    description: string;
    addedDate?: string;
    inactivatedDate?: string;
    inactive?: boolean;
    batches?: MaterialBatch[];
    batchInventoryManagement?: boolean;
    vat?: number;
};

export type PriceListMaterial = {
    _id?: string;
    material?: string | LabMaterial;
    materialCode: string;
    code?: string;
    description: string;
    createdOn?: string;
    addedDate?: string;
    inactivatedDate?: string;
    inactive?: boolean;
    basePrice?: string;
    originalPrice?: string;
    price?: number;
    batchNumber?: string;
    discountedPrice?: number;
    quantity?: number;
    unitPrice?: number;
    totExclVat?: number;
    vat?: number;
    totInclVat?: number;
    batches?: MaterialBatch[];
    batchInventoryManagement?: boolean;
};

export enum MaterialListType {
    NORMAL_PRICE_LIST = 'NORMAL_PRICE_LIST',
    CURRENCY_CONVERTED_PRICE_LIST = 'CURRENCY_CONVERTED_PRICE_LIST',
}

export type MaterialPriceList = {
    _id?: string;
    materialPriceListName: string;
    currency: string;
    conversionCurrency?: string;
    materialListType?: MaterialListType;
    conversionRate?: number;
    isStandardPriceList?: boolean;
    generalDiscount?: string;
    materials?: PriceListMaterial[];
    isUsingDefault?: boolean;
};

export type MaterialBatch = {
    _id?: string;
    isSaved?: boolean;
    batchNumber: string;
    quantity?: number;
    fullBatchQuantity: number;
    createdOn: Date;
    closed: boolean;
    closedDate?: Date;
};

export type AddedMaterial = {
    _id?: string;
    materialId?: string;
    code?: string;
    description?: string;
    material?: string | LabMaterial;
    batchNumber?: string;
    quantity?: number;
    price?: number;
    discountedPercent?: number;
    basePrice?: number;
    originalPrice?: number;
    vat?: number;
    originalVat?: number;
    priceWithoutVat?: number;
    priceWithVat?: number;
    batches?: MaterialBatch[];
    batchInventoryManagement?: boolean;
    materialActionId?: string;
};

export type TeethRange = {
    start: number;
    end: number;
};

export type MaterialFilter = {
    freetext: string;
    active: boolean | null;
};
